<div class="form-field" [formGroup]="formGroup">
  <label class="input-label" [id]="controlConfig.name + '-label'" [attr.for]="controlConfig.name">
    <span class="label-text">
      {{ controlConfig.label }}

      <span *ngIf="controlConfig.required">*</span>
    </span>

    <span class="info-icon" *ngIf="controlConfig.icon" aria-hidden="true">
      <svg-icon [src]="'assets/images/icons/' + controlConfig.icon + '.svg'"></svg-icon>
    </span>
  </label>

  <div class="input-container">
    <input
      [id]="controlConfig.name"
      [type]="controlConfig.type || 'text'"
      [formControlName]="controlConfig.name"
      [placeholder]="placeholder"
      [class.error]="isInvalid"
      [class.valid]="isValid"
      [class.disabled]="controlConfig.disabled"
      [attr.aria-invalid]="isInvalid"
      [attr.aria-describedby]="'error-message-' + controlConfig.name + ' ' + 'success-message-' + controlConfig.name" />

    <div class="validation-icon" *ngIf="isInvalid || isValid">
      <svg-icon *ngIf="isInvalid" [src]="'assets/images/icons/error.svg'" class="error-icon" aria-hidden="true"></svg-icon>
      <svg-icon *ngIf="isValid" [src]="'assets/images/icons/success.svg'" class="success-icon" aria-hidden="true"></svg-icon>
    </div>
  </div>

  <div [id]="'error-message-' + controlConfig.name" aria-live="assertive">
    <span class="error-message" *ngIf="errorMessage">
      <span class="sr-only">Fehler</span>
      {{ errorMessage }}
    </span>
  </div>

  <div [id]="'success-message-' + controlConfig.name" aria-live="assertive">
    <span class="sr-only" *ngIf="isValid">Eingabe gültig</span>
  </div>
</div>
